module.exports = __webpack_public_path__ + "static/img/gl-2.2f1ceba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery/gl-2.jpg
// module id = wxJm
// module chunks = 0